import { useSeo } from "../../hooks";

import { Container } from "../../components";

export const Seo = () => {
  const { seoData } = useSeo();

  if (!seoData || !seoData.text) return null;

  return (
    <section className="seo">
      <Container>
        <section dangerouslySetInnerHTML={{ __html: seoData.text }}></section>
      </Container>
    </section>
  );
};
